module.exports = __webpack_public_path__ + "img/kind_1.3d55a44a.jpg";